import * as Types from "../../Models/UserModel";
import * as ActionTypes from "../Actions/EnumTypes/ActionEnumTypes";
import { UserAction } from "../Actions/Models/UserActionModel";

export type State = Types.UserStore;

export const initialState: State = {
  token: null,
  user: null,
  loggedUserData: null,
  resetPasswordCode: null,
  isUserLogged: false,
  usersList: [],
  specificUser: null,
  treeStructure: null,
  contactsList: [],
  smsHistory: [],
};

export function userReducer(state: State = initialState, action: UserAction) {
  switch (action.type) {
    case ActionTypes.User.LOG_IN_SUCCESS: {
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isUserLogged: true,
      };
    }
    case ActionTypes.User.LOG_OUT_SUCCESS: {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("premium");
      return {
        ...state,
        loggedUserData: null,
        isUserLogged: false,
      };
    }
    case ActionTypes.User.GET_LOGGED_USER_DATA: {
      return {
        ...state,
        loggedUserData: action.payload.userData,
      };
    }
    case ActionTypes.User.SET_RESET_CODE: {
      return {
        ...state,
        resetPasswordCode: action.payload.code,
      };
    }
    case ActionTypes.User.TOKEN_VALID_FAILURE: {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      return {
        ...initialState,
        isUserLogged: false,
      };
    }
    case ActionTypes.User.TOKEN_VALID_SUCCESS: {
      return {
        ...state,
        isUserLogged: true,
      };
    }
    case ActionTypes.User.DELETE_USER_BY_ADMIN: {
      return {
        ...state,
        specificUser: null,
      };
    }
    case ActionTypes.User.GET_USERS_LIST: {
      return {
        ...state,
        usersList: action.payload.usersList,
      };
    }
    case ActionTypes.User.GET_SPECIFIC_USER: {
      return {
        ...state,
        specificUser: action.payload.specificUser,
      };
    }
    case ActionTypes.User.GET_TREE_STRUCTURE: {
      return {
        ...state,
        treeStructure: action.payload.tree,
      };
    }
    case ActionTypes.User.GET_CONTACTS_LIST: {
      return {
        ...state,
        contactsList: action.payload.contactsList,
      };
    }
    case ActionTypes.User.EDIT_USER: {
      return {
        ...state,
        loggedUserData: action.payload.data,
      };
    }
    case ActionTypes.User.EDIT_USER_BY_ADMIN: {
      return {
        ...state,
        // specificUser: { ...state.specificUser, ...action.payload.data },
        specificUser: action.payload.data,
      };
    }
    case ActionTypes.User.GET_SMS_HISTORY: {
      return {
        ...state,
        // specificUser: { ...state.specificUser, ...action.payload.data },
        smsHistory: action.payload.smsHistory,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/UserReducer.ts